import firebase from 'firebase';
import { HSLColor } from '../../types/color';

export interface Palette {
  colors: Array<HSLColor>;
  key: string | null;
}

export default class FirebasePalette {
  static fetchUserPalettes(uid: string) {
    return firebase.database()
      .ref('/palettes')
      .orderByChild('userId')
      .equalTo(uid)
      .once('value');
  }

  static saveUserPalette(palette: Palette, uid: string) {
    const newPaletteKey = firebase.database().ref().child('palettes').push().key;

    return firebase.database().ref(`palettes/${newPaletteKey}`).set({
      userId: uid,
      colors: palette.colors,
    });
  }
}
